import { tokenize } from "./normalize.js";
export function jaccard(a, b) {
    if (a.size === 0 || b.size === 0)
        return 0;
    let inter = 0;
    for (const x of a)
        if (b.has(x))
            inter++;
    return inter / (a.size + b.size - inter);
}
/**
 * Fraction of the need's terms the service accounts for. Asymmetric on purpose: a long service description
 * should not be penalised, what matters is whether it covers what was asked for.
 */
export function coverage(needTokens, serviceTokens) {
    if (needTokens.size === 0)
        return 0;
    let inter = 0;
    for (const x of needTokens)
        if (serviceTokens.has(x))
            inter++;
    return inter / needTokens.size;
}
export function lexicalScoreTokens(need, service) {
    const needSet = new Set(need.tokens);
    const serviceSet = new Set(service.tokens);
    const needConcepts = new Set(need.concepts);
    const serviceConcepts = new Set(service.concepts);
    const sharedConcepts = [...needConcepts].filter((c) => serviceConcepts.has(c)).sort();
    const sharedTokens = [...needSet].filter((t) => serviceSet.has(t)).sort();
    const conceptOverlap = jaccard(needConcepts, serviceConcepts);
    const tokenOverlap = jaccard(needSet, serviceSet);
    const cov = coverage(needSet, serviceSet);
    let base;
    if (sharedConcepts.length > 0) {
        // A shared concept alone can carry a pair into the confident band.
        base = 0.55 + 0.25 * conceptOverlap + 0.2 * Math.max(tokenOverlap, cov);
    }
    else {
        // Vocabulary outside the concept map, or genuinely unrelated: lean on overlap and stay below the confident band.
        base = 0.65 * cov + 0.35 * tokenOverlap;
    }
    // Conflicting concepts with no overlap is positive evidence against a match.
    if (needConcepts.size > 0 && serviceConcepts.size > 0 && sharedConcepts.length === 0)
        base *= 0.5;
    return {
        score: Math.max(0, Math.min(1, base)),
        needTokens: [...needSet].sort(),
        serviceTokens: [...serviceSet].sort(),
        needConcepts: [...needConcepts].sort(),
        serviceConcepts: [...serviceConcepts].sort(),
        sharedConcepts,
        sharedTokens,
        conceptOverlap,
        tokenOverlap,
        coverage: cov,
    };
}
export function lexicalScore(needText, serviceText) {
    return lexicalScoreTokens(tokenize(needText), tokenize(serviceText));
}
//# sourceMappingURL=lexical.js.map